import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class DictDrugPharmacologyIndex {
  private static like = ['ID', 'NAME', 'SPELL_CODE', 'STROKE_CODE']
  /**
   * 查询药理分类
   * @param parentId,父ID
   * @param skinTestCategory 皮试分类
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static query(parentId: string, skinTestCategory: string, keys: string = ''): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query(
        'DictDrugPharmacologyIndex',
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), skinTestCategory, parentId)
      )
    } else {
      return IndexExamine.queryByServer('DictDrugPharmacologyIndex', '', keys, this.like, {
        PARENT_ID: parentId,
        SKIN_TEST_CATEGORY: skinTestCategory
      })
    }
  }

  /**
   * 分页查询药品基础目录
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param parentId,父ID
   * @param skinTestCategory 皮试分类
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    parentId: string,
    skinTestCategory: string,
    keys: string = ''
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'DictDrugPharmacologyIndex',
        pageIndex,
        pageSize,
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), skinTestCategory, parentId)
      )
    } else {
      return IndexExamine.pageByServer(
        'DictDrugPharmacologyIndex',
        pageIndex,
        pageSize,
        '',
        keys,
        this.like,
        {
          PARENT_ID: parentId,
          SKIN_TEST_CATEGORY: skinTestCategory
        }
      )
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * @param category
   * @returns
   */
  private static QueryCondition(keys: string, skinTestCategory: string, parentId: string): string {
    let condition = []
    if (keys.trim()) {
      condition.push(
        `(id:*${keys}* OR name:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
      )
    }
    if (skinTestCategory.trim()) {
      condition.push(`skinTestCategory:${skinTestCategory}`)
    }
    if (parentId.trim()) {
      condition.push(`parentId:${parentId}`)
    }
    return condition.join(' AND ')
  }
}
